import _slicedToArray from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createAddress, createLPString } from '../../postcondition-types';
import { addressToString } from '../../common';
import { ClarityType } from '../constants';
import { utf8ToBytes } from '@stacks/common';

function principalToString(principal) {
  if (principal.type === ClarityType.PrincipalStandard) {
    return addressToString(principal.address);
  } else if (principal.type === ClarityType.PrincipalContract) {
    var address = addressToString(principal.address);
    return "".concat(address, ".").concat(principal.contractName.content);
  } else {
    throw new Error("Unexpected principal data: ".concat(JSON.stringify(principal)));
  }
}

function principalCV(principal) {
  if (principal.includes('.')) {
    var _principal$split = principal.split('.'),
        _principal$split2 = _slicedToArray(_principal$split, 2),
        address = _principal$split2[0],
        contractName = _principal$split2[1];

    return contractPrincipalCV(address, contractName);
  } else {
    return standardPrincipalCV(principal);
  }
}

function standardPrincipalCV(addressString) {
  var addr = createAddress(addressString);
  return {
    type: ClarityType.PrincipalStandard,
    address: addr
  };
}

function standardPrincipalCVFromAddress(address) {
  return {
    type: ClarityType.PrincipalStandard,
    address: address
  };
}

function contractPrincipalCV(addressString, contractName) {
  var addr = createAddress(addressString);
  var lengthPrefixedContractName = createLPString(contractName);
  return contractPrincipalCVFromAddress(addr, lengthPrefixedContractName);
}

function contractPrincipalCVFromAddress(address, contractName) {
  if (utf8ToBytes(contractName.content).byteLength >= 128) {
    throw new Error('Contract name must be less than 128 bytes');
  }

  return {
    type: ClarityType.PrincipalContract,
    address: address,
    contractName: contractName
  };
}

function contractPrincipalCVFromStandard(sp, contractName) {
  var lengthPrefixedContractName = createLPString(contractName);
  return {
    type: ClarityType.PrincipalContract,
    address: sp.address,
    contractName: lengthPrefixedContractName
  };
}

export { principalCV, principalToString, standardPrincipalCV, standardPrincipalCVFromAddress, contractPrincipalCV, contractPrincipalCVFromAddress, contractPrincipalCVFromStandard };